module.exports = __webpack_public_path__ + "static/media/RealTimeNotification.f6a40fd3.svg";